import { Injectable } from '@angular/core';
import { CanLoad, Route, Router, UrlSegment, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardLazyLoad implements CanLoad {
  constructor(private router: Router) {
  }
  // canLoad(
  //   route: Route,
  //   segments: UrlSegment[]): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
  //   return true;
  // }


  canLoad(route: Route): boolean {

    let url: string = route.path;
    console.log('Url:' + url);
    if (url == 'login/admin') {
      alert('You are not authorised to visit this page');
      return false;
    }
    return true;
  }
}



// import { CanLoad, Route, Router, UrlSegment } from '@angular/router';
// import { Observable } from 'rxjs';
// export class AuthGuardLazyLoad implements CanLoad {
//   constructor(private router: Router) {
//   }
//   canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
//     console.log("ROUTE IN CAN LOAD", route);

//     /* return true or false depending on whether you want to load that module or not
//    You can also use Observable/Promise resolving boolean value
//     */
//     return true
//   }

// }